import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DataUsageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"data_usage"}/>
}
